module.exports = __webpack_public_path__ + "img/medal_one_red.3e128c2e.png";